export const ConstStorage = {
    checkMyListLogged: 'check-my-list:logged',
    checkMyListTheme: 'check-my-list:theme'
}